import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICostCenterReferenceValue } from '../../../../../models/cost-center-reference-value.model';
import { IReferenceValueDialogLayout } from '../../../../../models/layout/reference-value-layout-dialog.model';
import { ICostCenterState } from '../../../../../services/facades/master-data/cost-center-state.model';
import { CostCenterFacade } from '../../../../../services/facades/master-data/cost-center.facade';
import { CostCenterLayoutService } from '../../../../../services/layout/cost-center-layout.service';

@Component({
    templateUrl: './add-reference-value-dialog.component.html',
    styleUrls: [ './add-reference-value-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddReferenceValueDialog implements OnInit {

    public costCenterState$: Observable<ICostCenterState>;
    public layout: IReferenceValueDialogLayout;
    public dialogFieldsValid$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public formGroup$: BehaviorSubject<FormGroup> = new BehaviorSubject<FormGroup>(null);

    constructor(
        private myMatDialogRef: MatDialogRef<AddReferenceValueDialog>,
        @Inject(MAT_DIALOG_DATA) public referenceValue: ICostCenterReferenceValue,
        private myCostCenterFacade: CostCenterFacade,
        private myCostCenterLayoutService: CostCenterLayoutService,
    ) {
    }

    public ngOnInit(): void {
        this.layout = this.myCostCenterLayoutService.getReferenceValueDialogLayout();
        this.costCenterState$ = this.myCostCenterFacade.subState();
    }


    public close(reload: boolean): void {
        this.myMatDialogRef.close(reload);
    }

    public async save(): Promise<void> {
        const value: ICostCenterReferenceValue = this.formGroup$.getValue().getRawValue() as ICostCenterReferenceValue;

        try {
            if (!isNullOrUndefined(this.referenceValue.id)) {
                // Edit
                await this.myCostCenterFacade.editBezugsgroessenWert(this.referenceValue.id, value.amount);
            } else {
                await this.myCostCenterFacade.addBezugsgroesseToKostenstelle(value);
            }
            this.close(true);
        } catch (e) {
            console.error(e);
        }
    }

    public onFormGroupChange(formGroup: FormGroup): void {
        formGroup.valueChanges.subscribe((v: ICostCenterReferenceValue) => {
            this.validateDialogFields(v);
        });
        this.formGroup$.next(formGroup);
    }

    private validateDialogFields(v: ICostCenterReferenceValue): void {
        if ((isNullOrUndefined(v.referenceId) && isNullOrUndefined(this.referenceValue.referenceId))
            || (isNullOrUndefined(v.costAccountingTypeId) && isNullOrUndefined(this.referenceValue.costAccountingTypeId))
            || (isNullOrUndefined(v.validFrom) && isNullOrUndefined(this.referenceValue.validFrom))
            || isNullOrUndefined(v.amount)
            || v.amount < 0) {
            this.dialogFieldsValid$.next(false);
        } else {
            this.dialogFieldsValid$.next(true);
        }
    }
}
